import React from 'react';
import { Bar } from 'react-chartjs-2';

const ClaimRepartitionBar = ({ clientChartData }) => {

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.raw; 
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: 'rgba(181, 181, 195, 1)',
          font: {
            size: 12,
            weight: 'bold',
          },
        },
      },
      y: {
        grid: {
          display: true,
          drawBorder: false,
        },
        ticks: {
          color: 'rgba(181, 181, 195, 1)',
          font: {
            size: 12,
            weight: 'bold',
          },
        },
      },
    },
    elements: {
      bar: {
        borderWidth: 2,
        borderRadius: 7,
      },
    },
  };

  const data = {
    labels: clientChartData.labels, // Same labels used in ApexChart
    datasets: [
      {
        label: clientChartData.label, // 'Nombre Sinistre Client'
        data: clientChartData.values, // Corresponding sinistre values
        backgroundColor: '#BCC704',
        borderColor: '#BCC704',
        borderWidth: 2,
        borderRadius: 7,
        barPercentage: 0.5,
        categoryPercentage: 0.5,
      },
    ],
  };

  return <Bar data={data} options={options} />;
};

export default ClaimRepartitionBar;
